import styled from '@emotion/styled';

export const BottomGutter = styled.div`
    margin-bottom: 10px;
`;

export const PatientCardLabel = styled.span`
    font-size: 12px;
    color: var(--manatee);
`;
